<template>
  <div class="game-table-flush">
  <vue-good-table 
    styleClass="vgt-table condensed vgt-flush"
    v-bind="tableOptions"
    :columns="columns"
    :rows="rows"
    :pagination-options="paginationFor(rows)"
    :row-click="true"
    @row-click="showWaitingGameDetail"
    compactMode>
    <template #table-row="props">
      <button 
        v-if="props.column.field == 'action'"
        @click="showWaitingGameDetail(props)"
        class="my-auto btn btn-link btn-icon-only btn-rounded btn-sm text-dark icon-move-right">
        <i class="ni ni-bold-right" aria-hidden="true"></i>
      </button>
      <span v-else>
        {{props.formattedRow[props.column.field]}}
      </span>
    </template>
    <template #emptystate>
      <div class="text-center">
        <span>Žádné čekající hry</span>
      </div>
    </template>
  </vue-good-table>
  </div>
</template>

<script setup>
import { reactive } from 'vue';
import { useStore } from 'vuex';
import { tableOptions, paginationFor } from '../../../../helpers/tableOptions';

const store = useStore();
const props = defineProps({
  rows: Array
})
const showWaitingGameDetail = (props) => {
  store.dispatch('loadOpenGameDetail', props.row.GameID);
}

const columns = reactive([
  { 
    label: 'Hra',
    field: 'GameName',
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder',
    tdClass: 'text-sm font-weight-bold',
  },
  { 
    label: 'Od',
    field: 'GameFrom',
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder text-end',
    tdClass: 'text-sm font-weight-bold text-end',
  },
  { 
    label: 'Detail',
    field: 'action',
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder text-md-center',
    tdClass: 'text-sm font-weight-bold text-md-center',
  }
]);

</script>